var exports = {
  "Bi": "MusicPanel.module__buttonWrap___a0dVbk",
  "W4": "MusicPanel.module__playingDot___a0dVbk",
  "nd": "MusicPanel.module__panel___a0dVbk",
  "RN": "MusicPanel.module__panelMobile___a0dVbk",
  "wx": "MusicPanel.module__header___a0dVbk",
  "DD": "MusicPanel.module__title___a0dVbk",
  "rf": "MusicPanel.module__body___a0dVbk",
  "lm": "MusicPanel.module__notice___a0dVbk",
  "Eb": "MusicPanel.module__activity___a0dVbk",
  "gb": "MusicPanel.module__iconButton___a0dVbk",
  "EM": "MusicPanel.module__iconButtonActive___a0dVbk",
  "uX": "MusicPanel.module__textButton___a0dVbk",
  "FB": "MusicPanel.module__nowPlaying___a0dVbk",
  "N6": "MusicPanel.module__nowPlayingRow___a0dVbk",
  "xn": "MusicPanel.module__thumbnail___a0dVbk",
  "Vd": "MusicPanel.module__trackText___a0dVbk",
  "eh": "MusicPanel.module__trackTitle___a0dVbk",
  "nf": "MusicPanel.module__trackMeta___a0dVbk",
  "OM": "MusicPanel.module__addedBy___a0dVbk",
  "qB": "MusicPanel.module__progress___a0dVbk",
  "TE": "MusicPanel.module__progressFill___a0dVbk",
  "Hn": "MusicPanel.module__times___a0dVbk",
  "ne": "MusicPanel.module__controls___a0dVbk",
  "$P": "MusicPanel.module__search___a0dVbk",
  "Rt": "MusicPanel.module__searchInput___a0dVbk",
  "p_": "MusicPanel.module__list___a0dVbk",
  "nM": "MusicPanel.module__row___a0dVbk",
  "_i": "MusicPanel.module__queueRow___a0dVbk",
  "mX": "MusicPanel.module__rowDragging___a0dVbk",
  "vz": "MusicPanel.module__rowOver___a0dVbk",
  "gR": "MusicPanel.module__queue___a0dVbk",
  "$t": "MusicPanel.module__queueHeader___a0dVbk",
  "Gf": "MusicPanel.module__sectionTitle___a0dVbk",
};

module.exports = exports;
